import React, { useState, useEffect, useMemo, useRef } from "react";
import { Box, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

const FADE_MS = 1000;
const ROTATE_MS = 5000;

export default function FreeShippingBanner({ appBarHeight }) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));

  const texts = useMemo(
    () => [
      "Livraison offerte sur toutes les commandes !",
      isXs
        ? "24€ de remise par cache dès le 2ème cache"
        : "Un proche souhaite aussi s'équiper ? Profitez d'une remise de 24€ par cache dès le deuxième.",
    ],
    [isXs],
  );

  const [currentText, setCurrentText] = useState(0);
  const [fade, setFade] = useState(true);
  const fadeTimeoutRef = useRef(null);

  useEffect(() => {
    setCurrentText(0);
    setFade(true);
  }, [isXs]);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setFade(false);
      if (fadeTimeoutRef.current) {
        clearTimeout(fadeTimeoutRef.current);
      }
      fadeTimeoutRef.current = window.setTimeout(() => {
        setCurrentText((prev) => (prev + 1) % texts.length);
        setFade(true);
      }, FADE_MS);
    }, ROTATE_MS);

    return () => {
      clearInterval(intervalId);
      if (fadeTimeoutRef.current) {
        clearTimeout(fadeTimeoutRef.current);
      }
    };
  }, [texts.length]);

  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 3,
        backgroundColor: "#5cb1e2",
        py: 1.25,
        px: 2,
        marginTop: `${appBarHeight}px`,
        textAlign: "center",
        minHeight: { xs: 40, sm: 45 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
      }}
    >
      <Typography
        component="p"
        sx={{
          color: "white",
          fontWeight: 500,
          fontFamily: '"Fira Sans", Sans-serif',
          fontSize: { xs: "11px", sm: "14px", md: "16px" },
          lineHeight: 1.25,
          opacity: fade ? 1 : 0,
          transition: `opacity ${FADE_MS}ms ease-in-out`,
          width: "100%",
          maxWidth: "100%",
          m: 0,
        }}
      >
        {texts[currentText]}
      </Typography>
    </Box>
  );
}
